import { useInView } from "react-intersection-observer";
import { Container } from "../Container";
import classNames from "classnames";
import { forwardRef } from "react";
import SmoothScrollbar from "smooth-scrollbar";
import "./IntroBanner.css";
import { observerOptions } from "../../constants/constants";

export const IntroBanner = forwardRef((props, ref) => {
  const observer = useInView(observerOptions);
  const { appRef, contactRef } = ref;

  return (
    <section className="intro__banner" ref={observer.ref}>
      <Container>
        <div className="intro__banner__title upper">
          <svg
            className="nexgen"
            width="134"
            height="29"
            viewBox="0 0 134 29"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M91.9802 16.4144V15.3387H77.9961V17.3307H89.8288C89.3905 22.5499 85.2869 26.7331 78.514 26.7331C71.0239 26.7331 65.9641 21.2351 65.9641 14.3825C65.9641 7.5299 71.0239 2.03188 78.3546 2.03188C82.7371 2.03188 86.6415 4.34264 88.4742 7.84863L90.3467 6.73309C88.0359 2.70917 83.5339 0 78.3546 0C69.8685 0 63.8526 6.41436 63.8526 14.3825C63.8526 22.3507 69.8685 28.765 78.514 28.765C86.8407 28.765 91.9802 23.1475 91.9802 16.4144ZM20.4383 0.438247H18.3267V24.4224L1.83267 0.438247H0V28.3268H2.11156V4.34264L18.5658 28.3268H20.4383V0.438247ZM44.1644 18.4463C44.1644 12.9881 40.3795 7.96815 34.3237 7.96815C28.2281 7.96815 24.005 12.51 24.005 18.3666C24.005 24.3825 28.3476 28.765 34.4831 28.765C38.4273 28.765 41.5349 26.9722 43.1684 24.263L41.4154 23.2272C40.26 25.3387 37.7899 26.8527 34.5229 26.8527C29.9811 26.8527 26.5548 23.9045 26.0767 19.4024H44.1246C44.1246 19.2431 44.1345 19.0837 44.1445 18.9244C44.1544 18.765 44.1644 18.6056 44.1644 18.4463ZM26.0767 17.4503C26.4751 13.0279 29.7819 9.88051 34.3237 9.88051C38.2281 9.88051 41.6544 12.5897 42.0927 17.4503H26.0767ZM62.6241 28.3268H60.1938L53.4607 19.6415L53.4565 19.6469L52.2575 18.0979L52.2655 18.0877L44.7754 8.4064H47.2057L53.4607 16.4941L53.4635 16.4905L55.4619 19.0722L55.4769 19.0606L62.6241 28.3268ZM54.687 14.9185L55.9015 16.4875L62.146 8.4064H59.7555L54.687 14.9185ZM51.0341 19.67L44.2973 28.3268H46.7276L52.2354 21.222L51.0341 19.67ZM104.244 7.96815C110.3 7.96815 114.085 12.9881 114.085 18.4463C114.085 18.6056 114.075 18.765 114.065 18.9244C114.055 19.0837 114.045 19.2431 114.045 19.4024H99.2422V17.4503H112.013C111.575 12.5897 108.149 9.88051 104.244 9.88051C99.7024 9.88051 96.3956 13.0279 95.9972 17.4503H96.0314C95.973 18.0659 95.9623 18.7794 96.0229 19.4024H95.9972C96.4753 23.9045 99.9016 26.8527 104.443 26.8527C107.71 26.8527 110.181 25.3387 111.336 23.2272L113.089 24.263C111.455 26.9722 108.348 28.765 104.404 28.765C98.2682 28.765 93.9255 24.3825 93.9255 18.3666C93.9255 12.51 98.1486 7.96815 104.244 7.96815ZM134 15.9363C134 11.1156 131.012 7.96815 126.271 7.96815C123.203 7.96815 120.653 9.24305 119.139 12.1913V8.4064H117.147V28.3268H119.139V17.8088C119.139 12.4303 122.207 9.88051 126.112 9.88051C129.857 9.88051 131.968 12.271 131.968 15.9363V28.3268H134V15.9363Z"
              fill="#1B1B1B"
            />
          </svg>

          <div className={classNames("intro__banner__word", { introBannerWordAnim: observer.inView })}>One</div>
          <div className={classNames("intro__banner__word lightItalic", { introBannerWordAnim: observer.inView })}>
            step
          </div>
        </div>
        <div className="intro__banner__title lower">
          <div className={classNames("intro__banner__word", { introBannerWordAnim: observer.inView })}>to </div>
          <div className={classNames("intro__banner__word lightItalic", { introBannerWordAnim: observer.inView })}>
            change
          </div>
        </div>
        <div className="intro__banner__row">
          <div className="intro__banner__column">
            <div className="intro__banner__column__text">
              <div className="intro__banner__column__text__block">
                <p className={classNames({ introBannerTextBlockAnim: observer.inView })}>
                  Our utmost dedication lies in enhancing our client's businesses' worth throughout every phase, from
                  planning to maintenance.
                </p>
              </div>
              <div className="intro__banner__column__text__block">
                <p className={classNames({ introBannerTextBlockAnim: observer.inView })}>
                  Our approach to design and development revolves around discovering the best possible solutions for our
                  clients and executing them with the utmost efficiency.
                </p>
              </div>
            </div>
          </div>
          <div
            className="intro__banner__column link"
            onClick={() => SmoothScrollbar.get(appRef.current).scrollTo(0, contactRef.current.offsetTop, 700)}
          >
            <div
              className={classNames("intro__banner__link__icon__container", { introBannerLinkAnim: observer.inView })}
            >
              <svg
                width="37"
                height="37"
                viewBox="0 0 37 37"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                className="intro__banner__link__icon"
              >
                <path
                  d="M30.3443 10.8504L4.88317 36.3115L0.699463 32.1279L26.1606 6.66667H3.71939V0.75H36.261V33.2917H30.3443V10.8504Z"
                  fill="black"
                />
              </svg>
            </div>
            <div
              className={classNames("intro__banner__link__title buttonTextUnderline", {
                introBannerLinkAnim: observer.inView,
              })}
            >
              Contact us
            </div>
          </div>
        </div>
      </Container>
    </section>
  );
});
